import UserLogged from './UserLogged.vue';
import Footer from './Footer.vue';
import HeroLayout from './HeroLayout.vue';
import LogoutConfirmation from './LogoutConfirmation.vue';
import Login from './Login.vue';
import { AutocompleteVehicles, MultipleSelectVehicle } from './FilterVehicles';
import MultipleSelect from './MultipleSelect.vue';
import MsgBox from './MsgBox.vue';
import Summary from './Summary.vue';
import SimpleTable from './SimpleTable.vue';
import SimpleMap from './SimpleMap.vue';
import Breadcrums from './Breadcrums.vue';
import LoadingDialog from './LoadingDialog.vue';
import LDialogOld from './LDialogOld.vue';
import CloseConfirmationModal from './CloseConfirmationModal.vue';
import Combobox from './Combobox.vue';
import SelectCompany from './SelectCompany.vue';
import FilterDate from './FilterDate.vue';
import DateRange from './DateRange.vue';
import Snackbar from './Snackbar.vue';
import StatsInfo from './StatsInfo.vue';
import ChartLayout from './ChartLayout.vue';
import VariableChart from './VariableChart.vue';
import VariableList from './VariableList.vue';
import FilterButton from './FilterButton.vue';
import ContextMenu from './ContextMenu.vue';
import PageTitle from './PageTitle.vue';
import PageCards from './PageCards.vue';
import Legend from './Legend.vue';
import MessageInfo from './MessageInfo.vue';
import { MapProvider, MapLoader, Map } from './Map';
import ModalInsuranceCompany from '../../insurance/components/ModalInsuranceCompany.vue';
import ModalInsuranceHarvest from '../../insurance/components/ModalInsuranceHarvest.vue';
import FarmingDetail from '../../insurance/components/FarmingDetail.vue';
import DetailHarvestSowing from '../../insurance/components/farming/DetailHarvestSowing.vue';
import DatePickerRange from './DatePickerRange.vue';
import DatePickerSingle from './DatePickerSingle.vue';
import PlusEyeButtons from './PlusEyeButtons.vue';
import TableArrows from './TableArrows.vue';
import Button from './Button.vue';
import Input from './Input.vue';
import AlertBox from './AlertBox.vue';
import InputFile from './Input.vue';
import InputFilterBox from './InputFilterBox.vue';
export {
    UserLogged,
    Footer,
    HeroLayout,
    LogoutConfirmation,
    Login,
    MapProvider,
    MapLoader,
    Map,
    AutocompleteVehicles,
    MultipleSelectVehicle,
    MultipleSelect,
    MsgBox,
    SimpleTable,
    SimpleMap,
    TableArrows,
    Button,
    Input,
    InputFilterBox,
    InputFile,
    AlertBox,
    Summary,
    ModalInsuranceHarvest,
    ModalInsuranceCompany,
    FarmingDetail,
    DetailHarvestSowing,
    DatePickerRange,
    DatePickerSingle,
    Breadcrums,
    PlusEyeButtons,
    Combobox,
    LoadingDialog,
    CloseConfirmationModal,
    SelectCompany,
    FilterDate,
    Snackbar,
    StatsInfo,
    VariableChart,
    LDialogOld,
    ChartLayout,
    VariableList,
    FilterButton,
    DateRange,
    Legend,
    MessageInfo,
    ContextMenu,
    PageTitle,
    PageCards
};
